import React from 'react';
import { Input, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { propTypes } from 'formsy-react';

class NumberFilterInput extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
      value: PropTypes.object,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      disabled: false,
      value: {},
    };
  }

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.clear = this.clear.bind(this);
    // the operator is stored in state the value is taken from props
    this.state = {
      operator: _.first(Object.keys(props.value)),
      number: _.first(Object.values(props.value)),
    };
  }

  changeValue(event) {
    const { value, name } = event.currentTarget;
    const newInputValue = value;
    let { operator: operatorValue, number: numberValue } = this.state;

    if (name === 'operator') {
      if (!newInputValue) {
        this.clear();
        return;
      }
      operatorValue = newInputValue || null;
      this.setState({ operator: operatorValue });
    }
    if (name === 'number') {
      numberValue = newInputValue ? Number.parseFloat(newInputValue) : null;
      this.setState({ number: numberValue });
    }

    if (operatorValue && numberValue) {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.onChange(this.props.name, { [operatorValue]: numberValue });
    }
  }

  clear() {
    this.setState({});
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(this.props.name, {});
  }

  render() {
    const { operator, number } = this.state;

    // Dont remove onChange from below.
    const { errorMessage, disabled } = this.props;
    return (
      <Row>
        <Col xs={5}>
          <Input
            disabled={disabled}
            type="select"
            name="operator"
            value={operator || undefined}
            onChange={this.changeValue}
          >
            <option> </option>
            <option value="eq">=</option>
            <option value="lte">{'<='}</option>
            <option value="gte">{'>='}</option>
          </Input>
        </Col>
        <Col xs={7}>
          <Input
            disabled={disabled}
            type="number"
            name="number"
            value={number || undefined}
            onChange={this.changeValue}
          />
          <span>{errorMessage}</span>
        </Col>
      </Row>
    );
  }
}

export default NumberFilterInput;
